
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class RepairTaxGrid extends Serenity.EntityGrid<RepairTaxRow, any> {
        protected getColumnsKey() { return 'Repair.RepairTax'; }
        protected getIdProperty() { return RepairTaxRow.idProperty; }
        protected getInsertPermission() { return RepairTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return RepairTaxRow.localTextPrefix; }
        protected getService() { return RepairTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}